import { render } from "./EventViewMailing.vue?vue&type=template&id=6ad6794d&lang=pug"
import script from "./EventViewMailing.vue?vue&type=script&lang=js"
export * from "./EventViewMailing.vue?vue&type=script&lang=js"

import "./EventViewMailing.vue?vue&type=style&index=0&id=6ad6794d&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__